import { NavLink, useLocation as useRouterLocation } from "react-router-dom";
import { House, MagnifyingGlass, Receipt, User, Gift } from "@phosphor-icons/react";
import { useAuthModal } from "../lib/authModal";
import { useAuth } from "../lib/auth";
import { useNotifications } from "../lib/notifications";

const ITEMS = [
  { to: "/", icon: House, label: "Início", testId: "nav-home" },
  { to: "/buscar", icon: MagnifyingGlass, label: "Buscar", testId: "nav-search" },
  { to: "/minhas-reservas", icon: Receipt, label: "Aluguéis", testId: "nav-rentals", auth: true, hasBadge: true },
  { to: "/recompensas", icon: Gift, label: "Recompensas", testId: "nav-rewards", auth: true },
  { to: "/perfil", icon: User, label: "Perfil", testId: "nav-profile", auth: true, hasDisputeBadge: true },
];

export default function BottomNav() {
  const { user } = useAuth();
  const { requireAuth } = useAuthModal();
  const router = useRouterLocation();
  const { bookingsBadge, disputesPending } = useNotifications();

  const handleClick = (e, item) => {
    if (item.auth && !user) {
      e.preventDefault();
      requireAuth(() => { window.location.href = item.to; });
    }
  };

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-30 bg-white border-t border-slate-200"
      style={{ paddingBottom: "var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px))" }}
      data-testid="bottom-nav"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-5">
        {ITEMS.map((it) => {
          const Icon = it.icon;
          const isActive = router.pathname === it.to;
          const badgeCount = it.hasBadge && user ? bookingsBadge : (it.hasDisputeBadge && user ? disputesPending : 0);
          return (
            <NavLink
              key={it.to}
              to={it.to}
              onClick={(e) => handleClick(e, it)}
              className={`relative flex flex-col items-center justify-center py-2.5 gap-0.5 text-[11px] font-medium transition-colors ${
                isActive ? "text-[#FF6B35]" : "text-slate-500 hover:text-[#004E98]"
              }`}
              data-testid={it.testId}
            >
              <div className="relative">
                <Icon size={22} weight={isActive ? "fill" : "regular"} />
                {badgeCount > 0 && (
                  <span
                    className="absolute -top-1.5 -right-2 min-w-[16px] h-4 px-1 rounded-full bg-red-500 text-white text-[9px] font-bold flex items-center justify-center shadow-md ring-2 ring-white"
                    data-testid={`${it.testId}-badge`}
                  >
                    {badgeCount > 99 ? "99+" : badgeCount}
                  </span>
                )}
              </div>
              <span>{it.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
